import Constants from '@usas/ui-web/utils/Constants';
import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

export const INITIAL_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
  dataAsOptionsWithNames: [],
  message: ''
};

export const defaultFrequentFlyerTypeState = {
  frequentFlyerTypeId: Constants.DEFAULT_ID,
  typeName: ''
};

const getFrequentFlyerTypes = (state, setState) => {
  if (state.isLoading !== true && state.isLoaded !== true && !state.message) {
    let newState = {
      ...state,
      isLoading: true,
      isLoaded: false,
      data: [],
      dataAsOptionsWithNames: [],
      message: 'Loading...'
    };
    setState(newState);

    const url = `/FrequentFlyerType`;
    CommonHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const blankFrequentFlyerType = { frequentFlyerTypeId: Constants.DEFAULT_ID, typeName: '--' };
          data.unshift(blankFrequentFlyerType);
          newState = {
            ...newState,
            isLoading: false,
            isLoaded: true,
            data: data,
            dataAsOptionsWithNames: data.map((frequentFlyerType) => { return { id: frequentFlyerType.frequentFlyerTypeId, name: frequentFlyerType.typeName } }),
            message: '',
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isLoading: false,
          isLoaded: false,
          message: message
        });
      });
  };
};

const FrequentFlyerTypeData = { INITIAL_STATE, getFrequentFlyerTypes };

export default FrequentFlyerTypeData;